"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointHeadersPatchIn = void 0;
class EndpointHeadersPatchIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointHeadersPatchIn.attributeTypeMap;
    }
}
exports.EndpointHeadersPatchIn = EndpointHeadersPatchIn;
EndpointHeadersPatchIn.discriminator = undefined;
EndpointHeadersPatchIn.attributeTypeMap = [
    {
        "name": "headers",
        "baseName": "headers",
        "type": "{ [key: string]: string; }",
        "format": ""
    }
];
//# sourceMappingURL=EndpointHeadersPatchIn.js.map